export const title = 'Total revenue';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.en.mdx';

Total revenue generated by sales attributed to campaigns.

<CampaignAttributionDateNote />
